import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import nameSort from 'scaleflow/utils/nameSort';

export default class IdeasTableCellCustomersComponent extends DropdownActivator {
  @service store;
  @tracked customerFormIsVisible = false;
  selectedIdea = null;

  get idea() {
    return this.args.idea;
  }

  @action
  handleCustomersChange(idea, e) {
    const customers = e.map((id) => this.store.peekRecord('customer', id));
    idea.set('customers', customers);
    idea.save();
  }

  @action
  toggleCustomerForm(idea, val) {
    if (idea) this.selectedIdea = idea;
    else this.selectedIdea = null;
    if (val !== undefined) this.customerFormIsVisible = val;
    else this.customerFormIsVisible = !this.customerFormIsVisible;
  }

  @action
  async onCustomerAdded(customer) {
    const customers = [...this.selectedIdea.customers.content];
    customers.push(customer);
    this.selectedIdea.customers = customers;
    await this.selectedIdea.save();
  }

  get customersList() {
    const customers = this.store.peekAll('customer').map((item) => ({
      value: item.id,
      label: item.name,
    }));
    return customers;
  }

  get sortedCustomers() {
    return this.idea.customers?.content?.toSorted((a, b) =>
      nameSort(a.name, b.name, 'asc'),
    );
  }

  get firstCustomer() {
    return this.sortedCustomers?.[0];
  }

  willDestroy() {
    this.customerFormIsVisible = false;
    this.selectedIdea = null;
    super.willDestroy(...arguments);
  }
}
